<template>
    <div class="card" id="print-auc-info">
        <header class="card-header">
            <p class="card-header-title">Auction Info:</p>
            <a href="#" class="card-header-icon" aria-label="more options">
                  <span class="icon ">
                    <i class="fas fa-gavel"></i>
                  </span>
            </a>
        </header>
        <div class="">
            <div class="content">
                <table class="table">
                    <tbody>
                    <tr>
                        <th>Lot#:</th>
                        <td>{{ lot.bid }}</td>
                    </tr>
                    <tr>
                        <th>Date & time:</th>
                        <td>{{ lot.lot_date }}</td>
                    </tr>
                    <tr>
                        <th>Auction:</th>
                        <td>{{ lot.auction_name }}</td>
                    </tr>
                    <tr>
                        <th>Score:</th>
                        <td><strong class="has-text-danger">{{ lot.scores }}</strong></td>
                    </tr>
                    <tr>
                        <th>Start price:</th>
                        <td><strong><a href="#" v-on:click.prevent="openMarketPrice(lot.lot_id)" class="has-text-danger tooltip" data-tooltip="Market price check">{{ lot.start_price_en * 1000 | formatNumber }} <i class="fas fa-search-dollar"></i></a></strong></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <market-price v-if="getMarketPriceStatus(lot.lot_id)"
                      v-bind:lot="lot"
                      :key="lot.lot_id" />
    </div>
</template>

<script>
    import marketPrice from './MarketPrice.vue'
    export default {
        props:['lot'],
        components: {
            marketPrice: marketPrice
        },
        methods: {
            openMarketPrice(lotId) {
                this.$store.dispatch('changeMarketPriceModalStatus', { status: true, lotId: lotId })
            },
            getMarketPriceStatus: function (lotId) {
                return this.$store.getters.getMarketPriceModalStatus(lotId)
            }

        }
    }
</script>

<style scoped>
    table {
        font-size: small;
    }
</style>




// WEBPACK FOOTER //
// src/components/Auctions/Lot/Details/AucInfo.vue